import { useState } from 'react';
import { CookieAcceptDialog, CookiePersonalizeDialog } from "@gisce/oficina-virtual-components";
import { Box } from "@mui/material";
import { useSettingsContext } from '../Settings/hooks/useSettingsContext';
import { useCookies } from "@/hooks/useCookies";

const CookieDialog = () => {
  const {acceptConsentCookies, acceptPreferencesCookies, acceptStatisticCookies, acceptMarketingCookies, acceptAllCookies, acceptCookies, hasAcceptedCookies} = useCookies();

  const [showPreferences, setShowPreferences] = useState(false);
  const [showBanner, setShowBanner] = useState(!hasAcceptedCookies());
  const Settings = useSettingsContext();

  const acceptedCookiesMap = {
    consent: acceptConsentCookies,
    preferences: acceptPreferencesCookies,
    statistics: acceptStatisticCookies,
    marketing: acceptMarketingCookies,
  };

  const acceptCookiesDialog = (acceptedCookies) => {
    setShowBanner(false);
    if (acceptedCookies === "all") {
      acceptAllCookies();
    } else if (typeof acceptedCookies === "object") {
      for (const [key, value] of Object.entries(acceptedCookies)) {
        if(value) {
          acceptedCookiesMap[key]();
        }
      }
      acceptCookies();
    }
  };

  const personalizeCookies = () => {
    setShowPreferences(true);
  };

  return (
    <Box sx={{position: "fixed", bottom: 0, width: "100%", zIndex: 10 }}>
      {showBanner && !showPreferences && (
        <CookieAcceptDialog
          acceptCookies={acceptCookiesDialog}
          personalizeCookies={personalizeCookies}
          cookiePolicyHref={Settings?.links?.cookies}
        />
      )}
      {showBanner && showPreferences && (
        <CookiePersonalizeDialog
          acceptCookies={acceptCookiesDialog}
          cookiePolicyHref={Settings?.links?.cookies}
        />
      )}
    </Box>
  );
}

export default CookieDialog;